
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { email } from "@/validators";
import { requiredIf } from "vuelidate/lib/validators";
import { InvoiceFrequency } from "@/constants/invoiceFrequency";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  data() {
    return {
      invoiceFrequency: InvoiceFrequency
    };
  },
  watch: {
    "$v.$invalid": "setValidity"
  },
  computed: {
    invoiceEmail: {
      get(): any {
        return (
          store.state.application.applicationData &&
          store.state.application.applicationData.finalDetails &&
          store.state.application.applicationData.finalDetails.invoiceEmail
        );
      },
      set(value: string) {
        (this as any).$v.invoiceEmail.$touch();
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_INVOICE_EMAIL),
          value
        );
      }
    },
    invoiceDate: {
      get(): any {
        return (
          store.state.application.applicationData &&
          store.state.application.applicationData.finalDetails &&
          store.state.application.applicationData.finalDetails.invoiceDate
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_INVOICE_DATE),
          value
        );
      }
    },
    paymentPlan: {
      get(): any {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.finalDetails &&
            store.state.application.applicationData.finalDetails.paymentPlan) ||
          null
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_PAYMENT_PLAN),
          value
        );
      }
    },
    hasPromoOfferPaymentPlan(): boolean {
      const applicationData = store.state.application.applicationData;

      const promoCode =
        applicationData &&
        applicationData.loyaltyDetails &&
        applicationData.loyaltyDetails.promoCode;

      return Boolean(promoCode && !this.paymentPlan);
    },
    ...mapGetters([APPLICATION.GETTERS.IS_EDITABLE])
  },
  methods: {
    setValidity() {
      this.$emit("isvalid", "invoice", !(this as any).$v.$invalid);
    }
  },
  validations: {
    invoiceEmail: {
      required: requiredIf(vm => vm.isEditable),
      email
    }
  }
});
